import * as React from "react";

function SvgConciergeBellSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M13.25 7.1v-.725h.625c.345 0 .625-.28.625-.625v-.625a.625.625 0 00-.625-.625h-3.75a.625.625 0 00-.625.625v.625c0 .345.28.625.625.625h.625v.724c-4.239.608-7.5 4.244-7.5 8.651h17.5c0-4.407-3.261-8.043-7.5-8.65zm8.125 9.9H2.625a.625.625 0 00-.625.625v1.25c0 .345.28.625.625.625h18.75c.345 0 .625-.28.625-.625v-1.25a.625.625 0 00-.625-.625z"
        fill="currentColor"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgConciergeBellSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
